import { AccountSessionResponse, DashboardLinkResponse, PaymentsResponse } from 'types/payment';

import { api } from './setupApi';

class PaymentsModel {
  link = '/payments';

  showLink = `${this.link}`;

  setupPaymentsLink = `${this.link}/setup_payments`;

  dashboardLink = `${this.link}/dashboard_link`;

  accountSessionLink = `${this.link}/account_session`;

  removeAccountLink = `${this.link}/remove_account`;

  getPayments = (): Promise<PaymentsResponse | null> =>
    api
      .get<PaymentsResponse>(this.showLink, {
        validateStatus: status => status === 200 || status === 404,
      })
      .then(({ status, data }) => (status === 404 ? null : data));

  setupPayments = (): Promise<PaymentsResponse> =>
    api.post<PaymentsResponse>(this.setupPaymentsLink).then(({ data }) => data);

  getDashboardLink = (): Promise<DashboardLinkResponse> =>
    api.get<DashboardLinkResponse>(this.dashboardLink).then(({ data }) => data);

  createAccountSession = (): Promise<AccountSessionResponse> =>
    api.post<AccountSessionResponse>(this.accountSessionLink).then(({ data }) => data);

  removeAccount = (): Promise<void> => api.delete(this.removeAccountLink).then(() => undefined);
}

export const paymentsModel = new PaymentsModel();
